module.exports = __webpack_public_path__ + "static/media/moldura-rg-frente.b00a8321.svg";